import type { MapMarker, MarkerClusterOptions, MarkerLayerOptions } from '@gpx-spa/geo-domain'
import type { LatLngBounds } from '@gpx-spa/geo-domain'
import type { GeoJsonFeatureCollection } from '@gpx-spa/geo-domain'
import mapboxgl from 'mapbox-gl'
import type { FeatureCollection } from 'geojson'

export function toMapboxBounds(b: LatLngBounds): mapboxgl.LngLatBounds {
  return new mapboxgl.LngLatBounds(
    [b.southWest.lng, b.southWest.lat],
    [b.northEast.lng, b.northEast.lat]
  )
}

export function cloneFeatureCollection(collection: GeoJsonFeatureCollection): FeatureCollection {
  return JSON.parse(JSON.stringify(collection)) as FeatureCollection
}

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function resolveClusterConfig(options?: MarkerLayerOptions): MarkerClusterOptions | null {
  const c = options?.cluster
  if (c === true) return {}
  if (c && typeof c === 'object') return c
  return null
}

export function htmlPopupText(m: MapMarker): string {
  const fallback =
    m.style.kind === 'circle' && m.style.label?.trim() ? m.style.label.trim() : ''
  return m.popup ?? fallback
}
